export enum ScannerModels {
  Model52 = 'model52',
  Model521 = 'model521',
}

export default ScannerModels;
